module.exports = __webpack_public_path__ + "img/qxgl.2aa4b806.png";